// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useFormik } from "formik";
// COMPONENTS
import { Modal, Button, Form } from 'react-bootstrap';
import { FilePond } from "react-filepond";
// CUSTOM COMPONENTS
import * as alert from '../../../redux/alertSnackBarRedux';
// SERVICES AND HELPERS
import constants from '../../../constants/constants';
import { getInputClasses, convertJsonToFormData } from "../../../helpers/helper";
import UploadFormValidator from '../../../helpers/validators/UploadFormValidator';
import * as formService from '../../../services/form/formService';

const UploadFormModal = (props) => {
    var initialValues = {
        id: 0,
        formTypeId: 0,
        filePath: '',
        name: '',
        description: ''
    }
    const { open, closeModal, formId, refreshForms, showAlert, formIdToEdit } = props;
    const [uploadForm, setUploadForm] = useState(initialValues);
    const [file, setFile] = useState(null);
    const [showUpload, setShowUpload] = useState(true);

    useEffect(() => {
        if (formIdToEdit) {
            formService.getFormById(formIdToEdit).then(res => {
                setUploadForm(res);
                setShowUpload(false);
            });
        } else {
            setUploadForm(initialValues);
            setShowUpload(true);
        }
        setFile(null);

    }, [formIdToEdit])

    const saveUploadForm = (formData, setSubmitting) => {
        formService.saveUploadForm(formData).then(res => {
            refreshForms();
            showAlert({ message: res.message, variant: 'success' });
            formik.resetForm();
            setFile(null);
            closeModal();
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
            setSubmitting(false);
        });
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: uploadForm,
        validationSchema: UploadFormValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            if (uploadForm.id == 0 && !file) {
                showAlert({ message: "Please upload a file before submitting the form", variant: "error" });
                setSubmitting(false);
                return;
            }

            saveUploadForm(convertJsonToFormData({ ...values, file: file ? file[0].file : null }), setSubmitting);
        }
    });

    return (
        <Modal centered size="lg" show={open} onHide={closeModal}>
            <form className="card card-custom" onSubmit={formik.handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title> {uploadForm.id > 0 ? "Edit" : "Create"} Upload Form</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form">
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Upload File
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                {
                                    showUpload ?
                                        <FilePond
                                            files={file}
                                            onupdatefiles={(uploadedFile) => {
                                                formik.setFieldValue("name", (uploadedFile.length > 0) ? uploadedFile[0].file.name.split('.')[0] : "");
                                                setFile(uploadedFile)
                                            }}
                                            labelIdle='Drag & Drop file or <span class="filepond--label-action">Browse</span>'
                                        /> :
                                        <div className="d-flex justify-content-around w-50">
                                            <a target="_blank" href={constants.API_URL + uploadForm.filePath} className="btn btn-primary">View Uploaded File</a>
                                            <button onClick={() => setShowUpload(true)} className="btn btn-danger">Replace File</button>
                                        </div>
                                }
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Name
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <input
                                        placeholder="Start typing..."
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "name")}`}
                                        name="name"
                                        {...formik.getFieldProps("name")}
                                    />
                                </div>
                                {formik.touched.name && formik.errors.name ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.name}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Description
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <Form.Control as="textarea" rows="5"
                                        placeholder="Start typing..."
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "description")}`}
                                        name="description"
                                        {...formik.getFieldProps("description")}
                                    />
                                </div>
                                {formik.touched.description && formik.errors.description ? (
                                    <div className="invalid-feedback display-block">
                                        {formik.errors.description}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal}>
                        Close
                    </Button>
                    <button
                        type="submit"
                        className="btn btn-success mr-2"
                        disabled={
                            formik.isSubmitting || (formik.touched && !formik.isValid)
                        }
                    >
                        {uploadForm.id > 0 ? "Save Changes" : "Create"}
                        {formik.isSubmitting}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    )

}

export default connect(null, { ...alert.actions })(UploadFormModal);